<template>
    <div class="seenotice">
        <h4>标题</h4>
    </div>
</template>

<script>
export default {
    name: "notice",
    data() {
        return {
        };
    },
    mounted() {},
    created() {},
    methods: {
        
    }
};
</script>

<style lang="scss" scoped>

</style>